module.exports = __webpack_public_path__ + "static/media/work-history.bef580eb.svg";